import React, { useState } from "react";
import PageHeader from "../components/PageHeader";

export default function Acts() {
  const [openIndex, setOpenIndex] = useState(0);

  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: "Acts", active: true },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div>
      <PageHeader title="महत्वपूर्ण अधिनियम" breadcrumbs={breadcrumbs} />

      <section className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-9 gov-accordion">

            {/* 1 */}
           <details
  className="info-block"
  open={openIndex === 0}
  onClick={() => toggleAccordion(0)}
>
  <summary onClick={(e) => e.preventDefault()}>
    <span className="arrow"></span>
    <span className="gov-title">POCSO Act, 2012</span>
  </summary>

  <div className="gov-body">

    {/* Heading */}
    <h6 className="gov-subheading">
      लैंगिक अपराधों से बालकों का संरक्षण (POCSO) अधिनियम, 2012
    </h6>

    <p>
      भारत सरकार द्वारा लैंगिक अपराधों से बालकों का संरक्षण अधिनियम, 2012 लागू किया गया है।
      यह अधिनियम नवम्बर 2012 से प्रभावशील है।
    </p>

    <p>
      बच्चों को यौन शोषण से बचाना तथा इसके प्रति जनजागरूकता पैदा करना इस कानून का उद्देश्य है।
      इस कानून के तहत पीड़ित बच्चे की पहचान प्रकट करना अपराध माना गया है।
      इस अधिनियम को पॉक्सो एक्ट के नाम से भी जाना जाता है।
      यह कानून बालक और बालिकाओं पर समान रूप से लागू है।
      किसी अवयस्क बच्चे द्वारा विधि का उल्लंघन करने पर उसे किशोर न्याय अधिनियम के तहत
      विचारण में लिया जायेगा।
      अधिनियम अंतर्गत 18 वर्ष से कम उम्र के बच्चे को 'बालक' माना गया है।
    </p>

    <p>
      अधिनियम अंतर्गत आयोग की शक्तियाँ इस अधिनियम की धारा 44 के अंतर्गत
      कानून के क्रियान्वयन के अनुश्रवण का दायित्व
      बाल अधिकार संरक्षण आयोगों को सौंपा गया है।
      इस अधिनियम के अधीन किसी अपराध से संबंधित किसी मामले की जाँच करते समय
      आयोग को वही शक्तियाँ प्राप्त होंगी जो
      बाल अधिकार संरक्षण आयोग अधिनियम 2005 के तहत प्राप्त है।
    </p>

    <p>
      बालकों के विरूद्ध लैंगिक अपराध – बच्चों के प्रति यौन हिंसा को
      लैंगिक अपराध की श्रेणी में माना जाता है।
      यह हिंसा कई प्रकार की होती है।
    </p>

    {/* Heading */}
    <h6 className="gov-subheading">अधिनियम के तहत अपराध</h6>

    <ol>
      <li>बच्चों का यौन शोषण करना या करवाना।</li>
      <li>यौन शोषण का प्रयास करना या करवाना।</li>
      <li>अश्लील साहित्य हेतु बच्चों का उपयोग करना या करवाना।</li>
    </ol>

    <p><strong>यह अपराध और अधिक गंभीर माना गया है जब :-</strong></p>

    <ul>
      <li>
        यह अपराध बच्चों के संरक्षण से जुड़े व्यक्ति
        (जैसे देखभाल संस्था, शिक्षक, लोक सेवक, पुलिस या शैक्षणिक संस्था) द्वारा किया जाता है।
      </li>
      <li>
        ऐसी घटनाओं को छुपाना या सूचना न देना भी अपराध माना जाता है।
      </li>
    </ul>

    {/* Heading */}
    <h6 className="gov-subheading">दंड का प्रावधान</h6>
<ul>
 <li>
      इस अधिनियम के तहत दोषी पाए जाने पर कठोर सजा का प्रावधान है
      जिसमें आजीवन कारावास का दण्ड हो सकता है।
    </li>

    <li>
      ऐसी घटना को छुपाने या सूचना न देने पर 6 माह से 1 वर्ष तक की कैद का प्रावधान है।
    </li>

    <li>
      कोई व्यक्ति जो धारा 19 एवं 20 के अधीन किसी अपराध की रिपोर्ट करने या
      अभिलिखित करने में विफल रहता है,
      वह 06 मास तक के कारावास या जुर्माने से या दोनों से दण्डित किया जा सकेगा।
      यह उपबंध किसी बालक पर लागू नहीं होगा।
    </li>

    <li>
      किसी कम्पनी या संस्था का भारसाधक व्यक्ति यदि रिपोर्ट करने में विफल रहता है
      तो वह 01 वर्ष तक के कारावास और जुर्माने से दण्डित किया जा सकेगा।
    </li>

    <li>
      कोई व्यक्ति जो इस अधिनियम के अंतर्गत किसी व्यक्ति या बालक को अपमानित करने के लिए
      मिथ्या सूचना या शिकायत करता है उसे 06 मास तक का कारावास या जुर्माने से
      या दोनों रूप में दण्डनीय होगा।
      जब कोई बालक मिथ्या सूचना देता है तो उस पर कोई दण्ड नहीं होगा।
    </li>
</ul>
   

    {/* Heading */}
    <h6 className="gov-subheading">
      प्रकरण पर कार्यवाही करने के लिए प्रक्रिया
    </h6>

    <ul>
      <li>सर्वप्रथम सूचना विशेष पुलिस इकाई या स्थानीय पुलिस थाने को दी जायेगी।</li>
      <li>पुलिस द्वारा सूचना को लेखबद्ध किया जाएगा।</li>
      <li>
        24 घंटे के भीतर बाल कल्याण समिति या विशेष न्यायालय को रिपोर्ट की जाएगी।
      </li>
      <li>
        बालक को रात्रि में किसी भी कारण से पुलिस स्टेशन में निरूद्ध नहीं किया जाएगा।
      </li>
      <li>
        बालक की पहचान मीडिया से सुरक्षित रखी जाएगी।
      </li>
      <li>
        पीड़ित बालक की चिकित्सकीय परीक्षा माता-पिता की उपस्थिति में की जाएगी।
      </li>
      <li>
        विशेष न्यायालय द्वारा मामलों का विचारण बंद कमरे में किया जाएगा।
      </li>
    </ul>

   {/* Heading */}
<h6 className="gov-subheading">
  लैंगिक अपराधों से बालकों का संरक्षण नियम, 2012 की धारा-6 के अनुसार
  अधिनियम के उपबंधों के कार्यान्वयन के लिए आयोग के कार्य
</h6>

<p>
  राज्य सरकारों द्वारा विशेष न्यायालयों के पदभिधान का मॉनीटर करना।
</p>

<ul>
  <li>
    राज्य सरकारों द्वारा, बालक की विचारण-पूर्व और विचारण के स्तर पर सहायता से
    सहबद्ध गैर-सरकारी संगठन, व्यवसायियों और विशेषज्ञों या मनोविज्ञान,
    सामाजिक कार्य, शारीरिक स्वास्थ्य, मानसिक स्वास्थ्य और बालक विकास का
    ज्ञान रखने वाले व्यक्तियों के उपयोग के लिए अधिनियम की धारा-39 में
    वर्णित मार्गदर्शी निर्देश तैयार करने तथा उन्हें लागू करने का अनुश्रवण।
  </li>

  <li>
    इस अधिनियम के अधीन अपने कार्यों के प्रभावी निर्वहन के लिए पुलिस कार्मिकों
    और अन्य संबंधित व्यक्तियों (जिसमें केन्द्रीय एवं राज्य सरकारों के अधिकारी
    भी सम्मिलित हैं) हेतु प्रशिक्षण योजनाओं के डिजाइन और कार्यान्वयन का
    अनुश्रवण।
  </li>

  <li>
    मीडिया (जिसमें टेलीविजन, रेडियो एवं प्रिंट मीडिया सम्मिलित हैं) के माध्यम
    से नियमित अंतराल पर अधिनियम के उपबंधों से संबंधित सूचनाओं के प्रसार हेतु
    केन्द्रीय एवं राज्य सरकारों को मॉनीटर करना एवं सहायता प्रदान करना, जिससे
    जनसाधारण, बालकों तथा उनके माता-पिता एवं संरक्षकों को जागरूक किया जा सके।
  </li>
</ul>

<p>
  <strong>(2)</strong> यथास्थिति, एनसीपीसीआर या एससीपीसीआर किसी सीडब्ल्यूसी
  की अधिकारिता के भीतर आने वाले बालक लैंगिक दुरुपयोग के किसी भी विनिर्दिष्ट
  मामले पर रिपोर्ट मांग सकेगी।
</p>

<p>
  <strong>(3)</strong> यथास्थिति, एनसीपीसीआर या एससीपीसीआर स्वप्रेरणा से या
  सुसंगत अभिकरणों से रिपोर्ट किए गए लैंगिक दुरुपयोग के मामलों से संबंधित
  सूचना एवं आंकड़े एकत्रित कर सकेगी, जिनमें निम्नलिखित शामिल हैं:
</p>

<ul>
  <li>अधिनियम के अधीन रिपोर्ट किए गए अपराधों की संख्या एवं विवरण।</li>
  <li>
    क्या अधिनियम एवं नियमों के अंतर्गत विहित प्रक्रियाओं का पालन किया गया है,
    जिसमें समय-सीमा से संबंधित प्रक्रियाएँ भी सम्मिलित हैं।
  </li>
  <li>
    अधिनियम के अधीन अपराधों के पीड़ितों की देखरेख एवं संरक्षण हेतु की गई
    व्यवस्थाओं का विवरण, जिसमें आपात चिकित्सा देखरेख एवं चिकित्सकीय
    परीक्षण भी शामिल हैं।
  </li>
  <li>
    संबंधित सीडब्ल्यूसी द्वारा किसी भी विनिर्दिष्ट मामले में बालक की
    देखरेख एवं संरक्षण की आवश्यकता निर्धारण से संबंधित विवरण।
  </li>
</ul>

<p>
  <strong>(4)</strong> यथास्थिति, एनसीपीसीआर या एससीपीसीआर इस प्रकार
  एकत्रित सूचना का उपयोग अधिनियम के उपबंधों के कार्यान्वयन का मूल्यांकन
  करने के लिए करेगी। अधिनियम की मॉनिटरिंग पर रिपोर्ट को एससीपीसीआर की
  वार्षिक रिपोर्ट में एक पृथक अध्याय के रूप में सम्मिलित किया जाएगा।
</p>


  </div>
</details>


            {/* 2 */}
            <details
              className="info-block"
              open={openIndex === 1}
              onClick={() => toggleAccordion(1)}
            >
              <summary onClick={(e) => e.preventDefault()}>
                <span className="arrow"></span>
                <span className="gov-title">Juvenile Justice (JJ) Act</span>
              </summary>
             <div className="gov-body">

  <h6 className="gov-subheading">
    किशोर न्याय (बालकों की देखरेख एवं संरक्षण) अधिनियम 2015
  </h6>

  <p>
    भारत सरकार द्वारा 0-18 वर्ष आयु के विधि से संघर्षरत बच्चों और देखभाल एवं सरंक्षण की आवश्यकता वाले बालक-बालिकाओं के लिए नवीन किशोर न्याय (बालकों की देखरेख और संरक्षण) अधिनियम, 2015 लागू किया गया है। इस नवीन अधिनियम के माध्यम से पूर्व के किशोर न्याय (बालकों की देखरेख और संरक्षण) अधिनियम, 2000 को निरस्त कर दिया गया है। भारत सरकार ने अधिसूचना जारी कर नवीन किशोर न्याय (बालकों की देखरेख और संरक्षण) अधिनियम, 2015 को 15 जनवरी 2016 से पूरे देश में प्रभावी किया है। इस अधिनियम में विधि से संघर्षरत बच्चों और देखभाल एवं सरंक्षण की आवश्यकता वाले बच्चों के संदर्भ में विशेष कानून का दर्जा दिया गया है। अधिनियम में 10 अध्याय एवं 112 धाराएँ है।
  </p>

  <h6 className="gov-subheading">उद्देश्य :</h6>
  <ul>
    <li>अधिनियम की प्रक्रिया के तहत् बच्चों के सर्वोत्तम हित को ध्यान में रखना।</li>
    <li>बाल मैत्री वातावरण का निर्माण करना।</li>
    <li>विधि से संघर्षरत बच्चों के लिए समुचित न्याय एवं कल्याण सुनिश्चित करना।</li>
    <li>देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों की देखरेख, संरक्षण, उपचार, विकास और पुनर्वास की व्यवस्था करना।</li>
    <li>विभिन्न तरह की हिंसा/शोषण से बच्चों की सुरक्षा सुनिश्चित करना।</li>
  </ul>
  <p>
    अधिनियम में उक्त प्रयोजन हेतु विभिन्न महत्वपूर्ण प्रावधान, प्रक्रियाएं, बाल संरक्षण सेवाओं, संस्थाओं की स्थापना एवं संचालन का प्रावधान किया गया है।
  </p>

  <h6 className="gov-subheading">सिद्धांत : -</h6>
  <h6 className="gov-subheading">
    1. इस अधिनियम के तहत् सभी बच्चों की देखरेख और संरक्षण हेतु आधारभूत सिद्धान्त निर्धारित किए गए है, जो निम्नानुसार है :-
  </h6>
  <ul>
    <li>बच्चों का सर्वोत्तम हित</li>
    <li>परिवार की जिम्मेदारी</li>
    <li>सुरक्षा, सकारात्मक उपाय</li>
    <li>गैर कलंकनीय भाषा का प्रयोग (जैसे बाल अपराधी न कहकर विधि विरूद्ध शब्द का उपयोग किया जायेगा)।</li>
    <li>समानता और भेदभाव न करना</li>
    <li>गोपनीयता का अधिकार (बच्चों की पहचान प्रकट न करना)।</li>
    <li>संस्थागत देखभाल अन्तिम विकल्प</li>
    <li>नये सिरे से शुरूआत एवं प्राकृतिक के सिद्धांत का पालन।</li>
  </ul>

  <h6 className="gov-subheading">
    किशोर न्याय (बालकों की देखरेख और सरंक्षण) अधिनियम, 2015 के मुख्य प्रावधान : -
  </h6>
  <p>
    विधि से संघर्षरत अथवा विधि का उल्लंघन करने वाले बच्चों के संदर्भ में इस कानून में सुधारात्मक प्रक्रियाओं के साथ-साथ विशेष परिस्थितिओं में दण्डात्मक व्यवस्था के प्रावधान किये गए हैं। ऐसे बालक-बालिकाएँ जिन्होंने किसी कानून का उल्लंघन किया है तथा अपराध के समय उसकी आयु 18 वर्ष से कम है, को विधि से संघर्षरत बालक माना गया है। कानून में छोटे अपराध (जिनमें 3 वर्ष तक की सजा है), गम्भीर अपराध (जिनमें 3 वर्ष से 7 वर्ष तक की सजा है) एवं जघन्य अपराध (जिनमें 7 वर्ष इससे अधिक की सजा है) को परिभाषित किया गया है।
  </p>

  <h6 className="gov-subheading">अधिनियम के तहत विधि विरूद्ध बच्चों के संबंध में प्रावधानः -</h6>
  <ul>
    <li>प्रकरणों की जाँच, सुनवाई एवं निस्तारण के लिए सक्षम प्राधिकारी के रूप में प्रत्येक जिलें में कम से कम एक किशोर न्याय बोर्ड की स्थापना का प्रावधान।</li>
    <li>किशोर न्याय बोर्ड- तीन सदस्यों की एक न्यायपीठ।</li>
  </ul>

  <h6 className="gov-subheading">संरचना :-</h6>
  <ul>
    <li>एक प्रिसिपल मजिस्ट्रेट एवं दो सामाजिक कार्यकर्ता।</li>
    <li>व्यक्ति/सदस्य को बाल कल्याण के क्षेत्र में 7 वर्ष का कार्यानुभव।</li>
  </ul>

  <h6 className="gov-subheading">मुख्य प्रावधानः -</h6>
  <ul>
    <li>बच्चों को अधिकतम 24 घंटे के अन्दर संबंधित किशोर न्याय बोर्ड के किसी सदस्य के समक्ष प्रस्तुत करना अनिवार्य।</li>
    <li>पुलिस द्वारा निरूद्ध विधि से संघर्षरत बच्चे के बारे में तत्काल अभिभावक या संरक्षक एवं परिवीक्षा अधिकारी को सूचित करना।</li>
    <li>ऐसे बच्चों के मामलों की जाँच, सुनवाई एवं निस्तारण के दौरान प्रत्येक स्तर पर बाल मैत्री वातावरण एवं प्रक्रियाओं के तहत् कार्यवाही करना।</li>
    <li>बच्चे के लिए विधिक सहायता उपलब्ध कराना।</li>
    <li>किन्ही परिस्थितियों में 16 से 18 वर्ष की आयु के जघन्य अपराध करने वाले विधि से संघर्षरत बच्चों के मामलों में जांच एवं विचारण का कार्य बाल न्यायालय (जिला एवं सत्र न्यायालय) द्वारा।</li>
    <li>बच्चों को जमानती अथवा गैर जमानती अपराध में पुलिस थाने/किशोर न्याय बोर्ड के स्तर पर जमानत दिये जाने के संबंध में स्पष्ट प्रावधान किये गये है।</li>
    <li>प्रत्येक बच्चे के प्रकरण में बोर्ड के कम से कम 2 सदस्यों द्वारा लिये गये निर्णय ही मान्य होगें।</li>
    <li>ऐसे बच्चे जिनकी आयु 18 वर्ष से कम है तथा उनके द्वारा कोई छोटे या गंभीर अपराध किया जाता है, तो ऐसे प्रकरणों का निस्तारण संबंधित बोर्ड द्वारा ही किया जायेगा।</li>
    <li>छोटे अपराध में संलिप्त विधि से संघर्षरत बच्चों के मामलों का निस्तारण अधिकतम 4 से 6 माह में किया जायेगा अन्यथा वे प्रकरण स्वतः ही समाप्त माने जायेंगे।</li>
    <li>ऐसे बच्चे जो कि 16 वर्ष की आयु पूर्ण कर चुके है तथा उनकी आयु 18 वर्ष से कम है, के द्वारा कोई जघन्य अपराध किया जाता है, तो ऐसे प्रकरणों में किशोर न्याय बोर्ड द्वारा विशेषज्ञों के सहयोग से 3 माह के अन्दर आवश्यक प्रारम्भिक आकलन किया जायेगा। तत्पश्चात ऐसे प्रकरणों में स्वयं के स्तर पर यह निर्णय लिया जायेगा कि जघन्य अपराध करने वाले विधि से संघर्षरत बच्चे का प्रकरण बोर्ड द्वारा ही निस्तारित किया जाये या इसे अग्रिम जाँच विचारण के लिए संबंधित बाल न्यायालय (जिला एवं सत्र न्यायालय) को हस्तांतरित किया जाए। ऐसे प्रकरणों में संबंधित किशोर न्याय बोर्ड एवं बाल न्यायालय (जिला एवं सत्र न्यायालय) की अहम भूमिका रहेगी।</li>
    <li>किशोर न्याय बोर्ड में लम्बित प्रकरणों की स्थिति की 3 माह में मुख्य न्यायिक मजिस्ट्रेट तथा 6 माह में अध्यक्ष, राज्य विधिक सेवा प्राधिकरण की समिति के स्तर पर समीक्षा की जायेगी।</li>
    <li>किशोर न्याय बोर्ड को विधि से संघर्षरत बच्चों के प्रकरणों की जाँच, सुनवाई एवं निस्तारण के अतिरिक्त बच्चों के विरूद्ध होने वाले अपराधों के प्रकरणों में आवश्यक कार्यवाही करने का दायित्व सौंपा गया है।</li>
    <li>किशोर न्याय बोर्ड जिले में संचालित जेलों का निरीक्षण कर वहाँ पर विचाराधीन विधि से संघर्षरत बच्चों की पहचान कर उन्हें पर्यवेक्षण गृह में हस्तान्तरित करने का कार्य भी करेगा।</li>
    <li>बच्चे, जिनके प्रकरण बोर्ड के समक्ष विचाराधीन है, के लिए बाल देखरेख संस्था के रूप में शासकीय अथवा गैर शासकीय पर्यवेक्षण गृह तथा सुरक्षित अभिरक्षा गृह की स्थापना का प्रावधान किया गया है।</li>
    <li>जिन प्रकरणों का बोर्ड/बाल न्यायालय द्वारा निस्तारित किया गया है, तथा विधि से संघर्षरत बच्चे को अभिरक्षा में रखने आदेश दिए गए है, उन बच्चों के लिए विशेष गृह/सुरक्षित अभिरक्षा गृह की व्यवस्था की गई है।</li>
    <li>16 से 18 वर्ष की आयु के जघन्य अपराध करने वाले विधि से संघर्षरत बच्चे, जिनके प्रकरण बाल न्यायालय के समक्ष विचाराधीन है, के लिए सुरक्षित अभिरक्षा गृह तथा जिनके प्रकरणों को बाल न्यायालय द्वारा निस्तारित किया गया है, वहां पर बच्चों को सुरक्षित अभिरक्षा गृह जेल में रखने का प्रावधान किया गया है।</li>
    <li>16 से 18 वर्ष की आयु के जघन्य अपराध करने वाले विधि से संघर्षरत बच्चे, जिनके प्रकरण बाल न्यायालय के समक्ष विचाराधीन है, का आपराधिक रिकार्ड संधारित किया जा सकेगा।</li>
    <li>किशोर न्याय बोर्ड के निर्णय के विरूद्ध 30 दिवस के अन्दर संबंधित जिला एवं सत्र न्यायालय में अपील की जा सकेगी । इसी प्रकार बाल न्यायालय के निर्णय के विरूद्ध उच्च न्यायालय में अपील की जा सकेगी।</li>
    <li>क्या न करें-किसी भी परिस्थिति में पुलिस द्वारा विधि से संघर्षरत बच्चों को जेल या लॉकअप में नहीं रखा जायेगा। विधि से संघर्षरत बच्चे तथा वयस्क द्वारा कारित अपराध के प्रकरण में संयुक्त कार्यवाही नहीं की जायेगी। विधि से संघर्षरत बच्चों को मृत्युदंड अथवा आजीवन कारावास की सजा नहीं दी जायेगी। जघन्य अपराध से संबंधित प्रकरणों को छोड़कर समस्त श्रेणी के प्रकरणों में विधि से संघर्षरत बच्चे का कोई आपराधिक रिकॉर्ड संधारित नहीं किया जायेगा।</li>
  </ul>

  <h6 className="gov-subheading">देखभाल एवं संरक्षण की आवश्यकता वाले बच्चे -</h6>

  <p>
    कानून की धारा 2 (14) में 18 वर्ष से कम उम्र के 12 श्रेणी के बालक बालिकाओं की देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों के रूप में परिभाषित किया गया है। इस श्रेणी में निम्न बच्चे शामिल हैंः -
  </p>
  <ul>
    <li>घर से भागे हुए बच्चे</li>
    <li>सड़क पर रहने वाले बच्चे</li>
    <li>भीख मांगने वाले बच्चे</li>
    <li>बाल श्रमिक</li>
    <li>उपेक्षित, शोषित, शारीरिक/मानसिक रूप से विकलांग तथा किसी अन्य असाध्य रोग (एच.आई.वी/एड्स. इत्यादि) से ग्रसित बच्चे</li>
    <li>अनाथ, परित्यक्त, समर्पित</li>
    <li>गुमशुदा बच्चे</li>
    <li>नशे से प्रभावित बच्चे</li>
    <li>हिंसा से पीड़ित बच्चे</li>
    <li>बाल विवाह से प्रभावित</li>
    <li>सशस्त्र संघर्ष, सिविल उपद्रव या प्राकृतिक आपदा से प्रभावित बच्चे सम्मिलित है।</li>
    <li>कानून में देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों की देखरेख, संरक्षण, उपचार, विकास और पुनर्वास के लिए आवश्यक निर्णय लेने हेतु जिला बाल कल्याण समिति सक्षम प्राधिकारी है। ऐसे बच्चों के प्रकरणों में जांच, सुनवाई एवं बच्चों के पुनर्वास के संदर्भ में प्रत्येक जिले में कम से कम एक बाल कल्याण समिति का गठन करने का प्रावधान किया गया है।</li>
    <li>प्रत्येक बाल कल्याण समिति में राज्य सरकार द्वारा नियुक्त एक अध्यक्ष एवं चार सदस्य होंगे। बाल कल्याण समिति को प्रथम न्यायिक मजिस्ट्रेट की शक्तियां प्राप्त होंगी।</li>
    <li>बाल कल्याण समिति में नियुक्त होने वाले व्यक्ति को बाल कल्याण के क्षेत्र में 7 वर्ष का अनुभव एवं निर्धारित योग्यता प्राप्त होना आवश्यक होगा।</li>
    <li>देखभाल एवं संरक्षण की आवश्यकता वाले प्रत्येक बच्चे को कोई भी प्राधिकारी/चाईल्ड लाईन (1098) / स्वयंसेवी संस्था/व्यक्ति द्वारा अधिकतम 24 घंटे के अंदर बाल कल्याण समिति के किसी एक सदस्य के समक्ष प्रस्तुत करना आवश्यक होगा।</li>
    <li>बाल कल्याण समिति के निर्णय के विरूद्ध 30 दिवस के अंदर संबधित जिला एवं सत्र न्यायालय में अपील प्रस्तुत की जा सकेगी, परंतु फॉस्टर केयर, प्रायोजन योजना एवं आफ्टर केयर से संबंधी अपील संबंधित जिला मजिस्ट्रेट के समक्ष प्रस्तुत की जायेगी।</li>
  </ul>

  <h6 className="gov-subheading">बच्चों के विरूद्ध अपराधों की प्रभावी रोकथाम हेतु दाण्डिक प्रावधान-</h6>
  <ul>
    <li>कोई भी प्राधिकारी/संस्था/अस्पताल/नर्सिंग होम/व्यक्ति जिसे कोई भी परित्यक्त, गुमशुदा अथवा अनाथ बच्चा मिलता है, तो उसे अधिकतम 24 घंटे के अन्दर चाइल्ड लाईन (1098) / पुलिस / बाल कल्याण समिति / पंजीकृत गृह / जिला बाल संरक्षण इकाई को सूचित करना आवश्यक होगा। ऐसा न करने पर अपराध माना जायेगा तथा ऐसे व्यक्ति को अधिकतम 6 माह की सजा अथवा 10,000 रूपये तक के जुर्माने से दण्डित किया जा सकेगा (धारा-34)</li>
    <li>कोई भी समाचार पत्र, पत्रिका या ऑडियो-विडियो मिडिया या अन्य कोई संवाद के माध्यम के द्वारा विधि से संघर्षरत बच्चे अथवा देखभाल एवं सरंक्षण की आवश्यकता वाले बच्चे अथवा पीड़ित बच्चे अथवा साक्षी बच्चे के संबंध में जांच, अन्वेषण या न्यायिक कार्यवाही के तहत् बच्चे की पहचान यथा बच्चे का नाम, पता व फोटो या अन्य विवरण को उजागर/प्रकाशन करता है, तो संबंधित व्यक्ति को 6 माह तक की सजा तथा 2 लाख रूपये तक जुर्माने से दण्डित किया जा सकेगा। (धारा-74)</li>
    <li>जो बच्चे का संरक्षक है, उसके द्वारा बच्चे पर प्रहार हमला किया जाता है या परित्याग किया जाता है या उत्पीड़न किया जाता है या जान-बूझकर बच्चे की उपेक्षा की जाती है, परित्याग या उत्पीड़न करवाता है, जिससे बच्चे को शारीरिक या मानसिक कष्ट होने की संभावना है, तो ऐसे व्यक्ति को अधिकतम 3 वर्ष की सजा तथा । लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। यदि ऐसी हिंसा/क्रूरता किसी संस्था के व्यक्ति के द्वारा की जाती है, जो उसकी सुरक्षा एवं देखभाल के उत्तरदायी है, तो उसे अधिकतम 5 वर्ष की सजा तथा 5 लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-75)</li>
   <li>कोई भी व्यक्ति जो बच्चे से भीख मंगवाने के लिए किसी बच्चे को नियोजित करता है या उसका उपयोग करता है या उससे भीख मंगवायेगा, तो उसे अधिकतम 5 वर्ष की सजा तथा । लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-76 (1))</li>
    <li>कोई भी व्यक्ति जो बच्चे का वास्तविक प्रभार अथवा नियंत्रण करता है, के द्वारा बच्चे से भीख मंगवाने के लिए किसी बच्चे को नियोजित करता है या उसका उपयोग करता है या उससे भीख मंगवाने हेतु दुष्प्रेरण करता है, तो उसे बच्चे की देखभाल एवं पालन-पोषण के लिए योग्य/उपयुक्त नहीं माना जायेगा। (धारा-76(2))</li>
    <li>कोई भी व्यक्ति बिना किसी अधिकृत चिकित्सक के आदेश पर सार्वजनिक स्थान पर बच्चे को नशीली शराब या नशीले पदार्थ/मादक औषधि या तम्बाकू उत्पाद देता है या दिलवाता है, तो उसे अधिकतम 7 वर्ष की सजा तथा 1 लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-77)</li>
    <li>कोई भी व्यक्ति नशीली शराब या नशीले पदार्थ/मादक औषधि के विक्रय, फुटकर क्रय-विक्रय, साथ रखने, आपूर्ति करने अथवा तस्करी में बच्चे का उपयोग करेगा, तो उसे अधिकतम 7 वर्ष की कठोर सजा तथा 1 लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-78)</li>
    <li>कोई भी व्यक्ति किसी कार्य के लिए बच्चे को अपने पास रखता है या बंधुआ रखता है या उसकी आय को रोकता या स्वयं के लिए उसका उपयोग करता है, तो उसे अधिकतम 5 वर्ष की कठोर सजा तथा । लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-79)</li>
    <li>कोई भी व्यक्ति या संस्था द्वारा अनाथ, परित्यक्त, समर्पित बच्चे को दत्तक ग्रहण/गोद देने की प्रक्रिया के बिना बच्चे को देने का प्रस्ताव रखता या देता है या प्राप्त करता है, तो उस व्यक्ति या संस्था को अधिकतम 3 वर्ष की सजा तथा । लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-80)</li>
    <li>कोई भी व्यक्ति किसी बच्चे को प्राप्त करता है, या खरीदता है या बेचता है, तो उसे अधिकतम 5 वर्ष की सजा तथा 1 लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। यदि ऐसा कार्य बच्चे का वास्तविक प्रभार अथवा नियंत्रणकर्ता के द्वारा अथवा अस्पताल/नर्सिंग होम/प्रसूति केन्द्र के कर्मचारी द्वारा किया जाता है, तो उसे न्यूनतम 3 वर्ष से अधिकतम 7 वर्ष तक की सजा से दण्डित किया जा सकेगा। (धारा-81)</li>
    <li>किसी बाल देखरेख संस्था में बच्चे का वास्तविक प्रभारकर्ता अथवा संस्था में कार्यरत कर्मचारी द्वारा बच्चे को अनुशासित करने के लिए जान-बुझकर शारीरिकि दण्ड दिया जाता है, तो उसके प्रथम अपराध पर 10,000 रूपये का जुर्माना तथा इस प्रकार की घटना/अपराध की पुनरावृत्ति करने पर उसे अधिकतम 3 माह की सजा तथा जुर्माने से दण्डित किया जा सकेगा। (धारा-82(1))</li>
    <li>बाल देखरेख संस्था द्वारा संस्था में बच्चों को शारीरिक दण्ड देने की घटना में संबंधित जांच में सहयोग नहीं दिया जाता है या किशोर न्याय बोर्ड या बाल कल्याण समिति के आदेशों का पालन नहीं किया जाता है, तो संस्था के प्रभारी को न्यूनतम 3 वर्ष की सजा तथा 1 लाख रूपये के जुर्माने से दण्डित किया जा सकेगा। (धारा-82(1))</li>
    <li>केन्द्र सरकार द्वारा गैर राजकीय स्वयंभू उग्रवादी समूह या दल के रूप में पहचान किए गए समूह या दल द्वारा किसी भी कार्य के लिए बच्चों को भर्ती/नियुक्त किया जाता है या उपयोग करता है, तो उसे अधिकतम 7 वर्ष की कठोर सजा तथा 5 लाख रूपये के जुर्माने का प्रावधान है। (धारा-83(1))</li>
    <li>किसी वयस्क व्यक्ति या वयस्क समूह द्वारा गैरकानूनी कार्य के लिए स्वयं के स्तर पर अथवा गैंग के रूप में बच्चे का उपयोग किया जाता है, उस व्यक्ति को अधिकतम 7 वर्ष की कठोर सजा तथा 5 लाख रूपये के जुर्माने का प्रावधान है। (धारा-83(2))</li>
    <li>उपरोक्त में से कोई भी अपराध किसी भी विकलांग बच्चे पर किया जाता है तो उसे अपराध की निर्धारित सजा से दुगुनी सजा से दण्डित किया जा सकेगा। (धारा-85)</li>
    <li>उपरोक्त में से कोई भी अपराध दुष्प्रेरण (बहकाना/उकसाना) के फलस्वरूप घटित हो जाता है, तो ऐसे दुष्प्रेरक व्यक्ति को भी अपराध की निर्धारित सजा से दण्डित किया जायेगा। (धारा-87)</li>
  </ul>

 <h6 className="gov-subheading">
    उपरोक्त बच्चों के विरूद्ध अपराधों के प्रकरणों का विचारण निम्नानुसार वर्णित न्यायालयों द्वारा किया जायेगाः -
  </h6>
  <ul>
    <li>ऐसे अपराध जिनमें 3 वर्ष से कम की सजा का प्रावधान है, या केवल जुर्माने का प्रावधान है वे गैर संज्ञेय, जमानती होंगे, जिनका विचारण किसी भी न्यायिक मजिस्ट्रेट द्वारा किया जायेगा।</li>
    <li>ऐसे अपराध जिनमें 3 वर्ष से 7 वर्ष की सजा का प्रावधान है, वे संज्ञेय, गैर जमानती होंगे, जिनका विचारण प्रथम न्यायिक मजिस्ट्रेट द्वारा किया जायेगा।</li>
    <li>ऐसे अपराध जिनमें 7 वर्ष से अधिक सजा का प्रावधान है, वे संज्ञेय, गैर जमानती होंगे, जिनका विचारण बाल न्यायालय (जिला एवं सत्र न्यायालय) द्वारा किया जायेगा।</li>
  </ul>

  <h6 className="gov-subheading">संस्थागत सेवाएं</h6>
  <p>
    विधि से संघर्षरत बच्चों के लिए सम्प्रेक्षण गृह, विशेष गृह, सुरक्षित अभिरक्षा गृह तथा देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों के लिए राजकीय अथवा गैर राजकीय बाल गृह, विशेष दत्तक ग्रहण एजेंसी, फिट फैसेलिटी तथा ओपन शेल्टर स्थापित/संचालित किए जायेंगे। 
  </p>
  <p>
    प्रत्येक बाल देखरेख संस्था में बच्चों के सर्वागीण विकास हेतु समस्त आवश्यक देखभाल, शिक्षण, जीवन कौशल एवं कौशल विकास इत्यादि सुविधाएं उपलब्ध कराई जायेगी। 
  </p>
  <p>
    कानून के अंतर्गत प्रत्येक शासकीय/गैर शासकीय (स्वयंसेवी संस्था द्वारा संचालित) बाल देखरेख संस्था को पंजीयन कराना अनिवार्य होगा। 
  </p>
  <p>
    कानून के अंतर्गत विधि से संघर्षरत बच्चों और देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों के लिए बिना पंजीयन के बाल देखरेख संस्था का संचालन करना अपराध होगा। ऐसी स्थिति में संस्था प्राधिकारी व्यक्ति को 1 साल की सजा तथा कम से कम 1 लाख रूपये का जुर्माना से दण्डित किया जा सकेगा। (धारा-42) 
  </p>
  <p>
    कानून के अंतर्गत बाल देखरेख संस्था के पंजीयन के प्रस्ताव पर राज्य सरकार के संबंधित अधिकारी द्वारा 6 माह में कार्यवाही नहीं करने पर उसे अपराध के रूप में परिभाषित किया गया है तथा संबंधित अधिकारी के विरूद्ध अनुशासनात्मक कार्यवाही की जा सकेगी। (धारा-41(5)) 
  </p>

  <h6 className="gov-subheading">गैर संस्थागत सेवाएं दत्तक ग्रहण (गोद देना)</h6>
  <p>
    कानून के तहत अनाथ, परित्यक्त एवं समर्पित बच्चों को परिवार उपलब्ध कराने के लिए दत्तक ग्रहण कार्यक्रम क्रियान्वित किया जायेगा। 
  </p>
  <p>
    अनाथ, परित्यक्त एवं समर्पित बच्चों का देश के अन्दर या देश के बाहर दत्तक ग्रहण संबंधी कार्यवाही इसी कानून के तहत की जायेगी। 
  </p>
  <p>
    अनाथ, परित्यक्त एवं समर्पित बच्चों के दत्तक ग्रहण में हिन्दू गोद देने और रखरखाव अधिनियम, 1956 लागू नहीं होगा। 
  </p>
  <p>
    किसी बच्चे का देश के अन्दर या देश के बाहर नजदीकी रिश्तेदार में दत्तक ग्रहण संबंधी कार्यवाही भी इसी कानून के तहत की जायेगी। 
  </p>
  <p>
    देश के बाहर रहने वाले भारतीय या भारत में जन्मे विदेश में रहने वाले व्यक्तियों को देश के बाहर दत्तक ग्रहण में वरीयता दी जायेगी। 
  </p>
  <p>
    जिला एवं सत्र न्यायालय द्वारा आवश्यक आदेश पारित करने के उपरान्त ही दत्तक ग्रहण वैध माना जायेगा। 
  </p>
  <p>
    प्रत्येक जिले में बच्चों के दत्तक ग्रहण करने के लिए विशेष दत्तक ग्रहण एजेंसियां स्थापित की जायेगी। 
  </p>
  <p>
    जिले में संचालित बाल देखरेख संस्थाओं में आवासरत दत्तक ग्रहण योग्य बच्चों के भी दत्तक ग्रहण के लिए विशेष दत्त्क ग्रहण एजेंसियां अधिकृत होगी। 
  </p>
  <p>
    राज्य में दत्तक ग्रहण को प्रोत्साहित करने तथा विशेष दत्तक ग्रहण एजेंसियों के कार्यों का पर्यवेक्षण करने का कार्य राज्य दत्तक ग्रहण संसाधन एजेंसी (सारा) द्वारा किया जायेगा। 
  </p>

    <h6 className="gov-subheading">फॉस्टर केयर (पालन-पोषण देखभाल)</h6>
  <p>
    देखभाल एवं संरक्षण की आवश्यकता वाले बच्चों को पारिवारिक वातावरण में पालन-पोषण एवं शिक्षा उपलब्ध करवाने के लिए फॉस्टर केयर (पालन-पोषण देखभाल) सेवाओं से जोड़ा जायेगा। 
  </p>
  <p>
    फॉस्टर केयर (पालन-पोषण देखभाल) में लाभान्वित बच्चे की देखभाल के लिए फॉस्टर पेरेन्ट्स को जिला बाल संरक्षण इकाई द्वारा मासिक स्तर पर आवश्यक आर्थिक सहायता भी उपलब्ध कराई जायेगी। 
  </p>

  <h6 className="gov-subheading">प्रायोजकता सेवाएं</h6>
  <p>
    ऐसे अनाथ बच्चे, जिनकी देखभाल किसी नजदीकी रिश्तेदार द्वारा की जा रही है, अथवा जिन बच्चों के माता-पिता किसी जानलेवा बीमारी से ग्रसित है अथवा विधवा/परित्यक्त/तलाकशुदा महिला के बच्चों को राज्य सरकार की ओर से प्रायोजकता सेवाओं के तहत निर्धारित आर्थिक सहायता उपलब्ध कराई जायेगी। 
  </p>

  <h6 className="gov-subheading">आफ्टर केयर (पश्चातवृति देखभाल)</h6>
  <p>
    प्रत्येक बालक जो बाल देखरेख संस्था से 18 वर्ष की आयु पूर्ण करने के उपरान्त बाहर जा रहा है, उसे समाज की मुख्यधारा से जोड़ने हेतु निर्धारित आर्थिक सहायता उपलब्ध कराई जायेगी। 
  </p>

  <h6 className="gov-subheading">किशोर न्याय (बालकों की देखरेख और संरक्षण) आदर्श नियम, 2016 अंतर्गत अनुश्रवण</h6>
  <p>
    राष्ट्रीय बाल अधिकार संरक्षण आयोग एवं राज्य बाल अधिकार संरक्षण आयोग द्वारा अनुश्रवण-
    बाल अधिकार संरक्षण आयोग अधिनियम, 2005 (2006 का 4) के अंतर्गत विनिर्दिष्ट कृत्यों के अलावा, केन्द्र और राज्य सरकार के परामर्श से राष्ट्रीय आयोग या राज्य आयोग आदि निम्नलिखित कृत्य संपादित करेंगे अर्थात :
  </p>
  <ul>
    <li>अधिनियम के अधीन सृजित की गई संस्थाओं की संरचनाओं की समीक्षा :</li>
    <li>बाल अधिकारों और जेंडर संवेदनशीलता पर सूचना, शिक्षा और संप्रेषण (आईईसी) सामग्री का विकास :</li>
    <li>बालकों के सुधार और पुनर्वास के लिए नवाचारों का विकास :</li>
    <li>बालकों के विरूद्ध अपराधों, जैसे कि नशीली दवाओं का दुरूपयोग, अवैध मानव व्यापर, बालकों का यौन दुरूपयोग और बाल विवाह सहित बालकों का शोषण और बालकों के विरूद्ध हिंसा के अन्य रूपों की पहचान करने और रिपोर्ट करने के बारे में जागरूकता विकास।</li>
    <li>उन्नत संरक्षण के लिए अपराधों की पहचान करने और रिपोर्ट करने सहित बालकों के विरूद्ध अपराधों के बारे में पंचायती राज संस्थाओं और नगर निगमों के लिए संचेतना कार्यशालाओं का आयोजन।</li>
    <li>पीड़ित बाल या साक्षियों और उनके परिवारों के अधिकारों के विस्तृत वर्णन के साथ और स्थानीय भाषा में उपयोगी जानकारी सहित सूचना सामग्री विकसित करना जैसे पीड़ित और उसके परिवार को उपलब्ध कराना।</li>
    <li>राज्य बाल संरक्षण सोसायटी, राष्ट्रीय जन सहयोग बाल विकास संस्थान आदि के साथ पक्षकारों के लिए प्रशिक्षण मॉड्यूल विकसित करना।</li>
    <li>बाल अधिकार संरक्षण आयोग अधिनियम, 2005 (2006 का 4) की धारा 3 के अधीन बालक अधिकारों के संरक्षण के लिए गठित राष्ट्रीय आयोग, धारा 17 के अधीन बालक अधिकारों के संरक्षण के लिए गठित राज्य आयोग, जैसी भी स्थिति हो (इसमें इसके पश्चात् यथास्थिति राष्ट्रीय आयोग अथवा राज्य आयोग के रूप में निर्दिष्ट), उक्त अधिनियम के अधीन उनको समनुदेशित कार्यों के अलावा इस अधिनियम के उपबंधों के क्रियान्वयन की उस रीति से अनुश्रवण करेंगे, जैसे विहित किया जाए।</li>
    <li>यथास्थिति राष्ट्रीय आयोग अथवा राज्य आयोग, को इस अधिनियम के अधीन किसी अपराध से संबंधित मामले की जांच करते समय, वही शक्तियां प्राप्त होगी जैसी राष्ट्रीय आयोग अथवा राज्य आयोग में बाल अधिकार संरक्षण आयोग अधिनियम, 2005 (2006 का 4) के अधीन निहित है।</li>
    <li>यथास्थिति राष्ट्रीय आयोग अथवा राज्य आयोग, बाल अधिकार संरक्षण आयोग अधिनियम, 2005 (2006 का 4) की धारा 16 में निर्दिष्ट वार्षिक रिर्पोट में इस धारा के अधीन उसके क्रियाकलाप भी शामिल होंगे।</li>
  </ul>


</div>


            </details>

            {/* 3 */}
            <details
              className="info-block"
              open={openIndex === 2}
              onClick={() => toggleAccordion(2)}
            >
              <summary onClick={(e) => e.preventDefault()}>
                <span className="arrow"></span>
                <span className="gov-title">Right to Education (RTE) Act</span>
              </summary>
              <div className="gov-body">
               <h6 className="gov-subheading">निःशुल्क एवं अनिवार्य बाल शिक्षा का अधिकार अधिनियम, 2009</h6>
<p>
  निःशुल्क तथा अनिवार्य बाल शिक्षा का अधिकार अधिनियम 2009 की धारा 31 में बाल अधिकार संरक्षण आयोग को इस अधिनियम के अनुश्रवण का दायित्व सौंपा गया है जो निम्नानुसार है :-
</p>
<p>
  बाल अधिकार संरक्षण आयोग अधिनियम, 2005 की, यथास्थिति, धारा 3 के अधीन गठित राष्ट्रीय बालक अधिकार संरक्षण आयोग या धारा 17 के अधीन गठित राज्य बाल अधिकार संरक्षण आयोग, उस अधिनियम के अधीन उन्हें समनुदेशित कृत्यों के अतिरिक्त निम्नलिखित कृत्यों का पालन करेगा, अर्थात्
</p>
<ul>
  <li>इस अधिनियम द्वारा या उसके अधीन उपबंधित अधिकारों की रक्षोपायों की परीक्षा और पुनर्विलोकन करना और उनके प्रभावी कार्यान्वयन के लिए अध्युपायों की सिफारिश करना।</li>
  <li>निःशुल्क और अनिवार्य शिक्षा के बालक के अधिकार संबंधी परिवादों की जांच करना।</li>
  <li>उक्त बाल अधिकार संरक्षण आयोग की धारा 15 और 24 के अधीन यथा उपबंधित आवश्यक उपाय करना।</li>
  <li>उक्त आयोग को, उपधारा (1) के खण्ड (ग) के अधीन निःशुल्क और अनिवार्य शिक्षा के बालक के अधिकार से संबंधित किसी विषय में जांच करते समय वहीं शक्तियां होंगी, जो उक्त बाल अधिकार संरक्षण आयोग अधिनियम को क्रमशः धारा 14 और धारा 24 के अधीन उन्हें समनुदेशित की गई है।</li>
  <li>जहाँ किसी राज्य में, राज्य बाल अधिकार संरक्षण आयोग गठित नहीं किया गया है वहां समुचित सरकार उपधारा (1) के खण्ड (क) से खण्ड (ग) में विनिर्दिष्ट कृत्यों का पालन करने के प्रयोजन के लिए ऐसी रीति में और ऐसे निबंधनों और शर्तों के अधीन रहते हुए जो विहित की जायें ऐसे प्राधिकरण का गठन कर सकेगी।</li>
</ul>

<h6 className="gov-subheading">धारा-32-शिकायतों को दूर करना</h6>
<p>
  धारा 31 में किसी बात के होते हुए भी, कोई व्यक्ति, जिसे इस अधिनियम के अधीन किसी बालक के अधिकार के संबंध में कोई शिकायत है, अधिकारिता रखने वाले स्थानीय प्राधिकार को लिखित में शिकायत कर सकेगा।
</p>
<p>
  उपधारा (1) के अधीन शिकायत प्राप्त होने के पश्चात् स्थानीय प्राधिकार, संबंधित पक्षकारों को सुने जाने का युक्तियुक्त अवसर प्रदान करने के पश्चात् मामले का यथाशीघ्र निपटारा करेगा।
</p>
<p>
  स्थानीय प्राधिकार के विनिश्चय से व्यथित कोई, व्यक्ति, यथास्थिति, राज्य बाल अधिकार संरक्षण आयोग को या धारा 31 की उपधारा (3) के अधीन विहित प्राधिकार को अपील कर सकेगा।
</p>
<p>
  उपधारा (3) के अधीन की गई अपील का विनिश्चय बाल अधिकारों के संरक्षण के लिए राज्य आयोग या यथास्थिति 31 की उपधारा (3) के अधीन विहित प्राधिकार द्वारा किया जायेगा।
</p>

<h6 className="gov-subheading">अनिवार्य तथा निःशुल्क शिक्षा का अधिकार अधिनियम 2009 के महत्वपूर्ण प्रावधान</h6>
<p>
  इस कानून के माध्यम से सभी 14 वर्ष तक के बच्चों को बिना भेद-भाव के आठवीं कक्षा तक पढ़ाई पूरी करने के लिये विविध प्रावधान किये गये हैं।
</p>
<p>
  इस कानून में निजी शालाओं को भी दुर्बल व वंचित वर्ग के परिवार के बच्चों को प्रारंभिक कक्षा में कुल प्रवेश की 25 प्रतिशत सीटों पर प्रवेश देने का प्रावधान हैं, जिस पर आने वाला व्यय राज्य सरकार द्वारा प्रतिपूर्ति किया जाता है।
</p>
<ul>
  <li>शिक्षक-छात्र अनुपात निर्धारित किया गया है।</li>
  <li>अधोसंरचना विकास के लिये विविध प्रावधान किये गये है।</li>
  <li>शिक्षा में गुणवत्ता बनाये रखने के लिये भी आवश्यक व्यवस्था करने के प्रावधान किये गये हैं।</li>
  <li>शारीरिक प्रताड़ना को पूरी तरह से प्रतिबंधित किया गया है।</li>
  <li>इस कानून के लागू होने के बाद से प्रारंभिक शिक्षा प्राप्त करना हर बच्चे का कानूनी हक है।</li>
  <li>कोई विद्यालय या व्यक्ति किसी बच्चे को प्रवेश देते समय किसी प्रकार का फीस नहीं लेगा और बच्चे या संरक्षक किसी प्रकार की अनुवीक्षण प्रक्रिया के अधीन नहीं रहेंगे। यदि विद्यालय या व्यक्ति इसका उल्लंघन करता है तो जुर्माना एवं दंड का प्रावधान है।</li>
  <li>प्राथमिक शिक्षा में प्रवेश के लिए किसी बच्चे की आयु का प्रमाण जन्म-मृत्यु और विवाह रजिस्ट्रीकरण अधिनियम के तहत जारी प्रमाण पत्र से लिया जायेगा। किसी बच्चे की आयु के सबूत न होने पर भी विद्यालय में प्रवेश दिया जायेगा।</li>
</ul>

              </div>
            </details>

            {/* 4 */}
            <details
              className="info-block"
              open={openIndex === 3}
              onClick={() => toggleAccordion(3)}
            >
              <summary onClick={(e) => e.preventDefault()}>
                <span className="arrow"></span>
                <span className="gov-title">Prohibition of Child Marriage (PCM) Act, 2006</span>
              </summary>
              <div className="gov-body">
               <h6 className="gov-subheading">बाल विवाह प्रतिषेध अधिनियम, 2006</h6>

<h6 className="gov-subheading">धारा-3 बाल विवाहों का, बंधन में आने वाले पक्षकार के, जो बालक है, विकल्प पर शून्यकरणीय होना</h6>
<p>
  प्रत्येक बाल-विवाह, जो चाहे इस अधिनियम के प्रारंभ के पूर्व या पश्चात् अनुष्ठापित किया गया हो, विवाह बंधन में आने वाले ऐसे पक्षकार के द्वारा ही जो विवाह के समय बालक था, जिला न्यायालय में अर्जी फाइल की जा सकेगी।
</p>
<p>
  यदि अर्जी फाइल किए जाने के समय, अर्जीदार अवयस्क है तो अर्जी संरक्षक या वाद-मित्र के साथ-साथ बाल-विवाह प्रतिषेध अधिकारी के मार्फत फाइल की जा सकेगी।
</p>
<p>
  इस धारा के अधीन अर्जी किसी भी समय फाइल की जा सकेगी, किन्तु बालक ने अर्जी फाइल करने के पूर्व वयस्कता प्राप्त करने के पश्चात् दो वर्ष पूरे कर लिए हों।
</p>
<p>
  इस धारा के अधीन अकृतता की डिक्री प्रदान करते समय जिला न्यायालय, विवाह के दोनों पक्षकारों और उनके माता-पिता या उनके संरक्षकों को यह निर्देश देते हुए आदेश करेगा कि वे, यथास्थिति, दूसरे पक्षकार, उसके माता-पिता या संरक्षक को विवाह के अवसर पर उसको दूसरे पक्षकार से प्राप्त धन, मूल्यवान वस्तुएँ, आभूषण और अन्य उपहार या ऐसी मूल्यवान वस्तुओं, आभूषणों, अन्य उपहारों के मूल्य के बराबर रकम और धन लौटा दें। परंतु इस धारा के अधीन कोई आदेश तब तक पारित नहीं किया जाएगा जब तक कि संबद्ध पक्षकारों को जिला न्यायालय के समक्ष उपस्थित होने और यह कारण दर्शित करने के लिए कि ऐसा आदेश क्यों नहीं पारित किया जाए, सूचनाएँ न दे दी गई हों।
</p>

<h6 className="gov-subheading">धारा-4 बाल-विवाह के बंधन में आने वाली महिला पक्षकार के भरण-पोषण और निवास के लिए उपबन्ध</h6>
<p>
  धारा 3 के अधीन डिक्री प्रदान करते समय, जिला न्यायालय बाल-विवाह के बन्धन में आने वाले पुरूष पक्षकार को और यदि ऐसे विवाह के बन्धन में आने वाला पुरूष पक्षकार अवयस्क है, तो उसके माता-पिता या संरक्षक को, विवाह के बन्धन में आने वाली महिला पक्षकार को, उसके पुनर्विवाह तक, भरण पोषण का संदाय करने के लिए निर्देश देते हुए अन्तरिम या अन्तिम आदेश भी कर सकेगा।
</p>
<p>
  संदेय भरण-पोषण की मात्रा का अवधारणा जिला न्यायालय द्वारा, बालक की आवश्यकताओं, अपने विवाह के दौरान ऐसे बालक द्वारा भोगी गई जीवन शैली और संदाय करने वाले पक्षकार की आय के साधनों को ध्यान में रखते हुए किया जायेगा।
</p>
<p>
  भरण-पोषण की रकम का मासिक या एक मुश्त राशि के रूप में संदाय करने का निर्देश दिया जा सकेगा।
</p>
<p>
  यदि धारा 3 के अधीन अर्जी देने वाला पक्षकार विवाह के बंधन में आने वाली स्त्री पक्षकार है तो जिला न्यायालय उसके पुनर्विवाह तक उसके निवास के लिए भी उपयुक्त आदेश कर सकेगा।
</p>

<h6 className="gov-subheading">धारा-5 बाल-विवाह से बालकों का भरण-पोषण और अभिरक्षा</h6>
<p>
  जहाँ बाल- विवाह से जन्में बालक है, वहाँ जिला न्यायालय ऐसे बालकों की अभिरक्षा के लिए समुचित आदेश करेगा।
</p>
<p>
  इस धारा के अधीन किसी बालक की अभिरक्षा के लिए कोई आदेश करते समय, बालक के कल्याण और सर्वोत्तम हितों पर जिला न्यायालय द्वारा सर्वोपरि ध्यान दिया जाएगा।
</p>
<p>
  बालक की अभिरक्षा के लिए किसी आदेश में, दूसरे पक्षकार की, ऐसे बालक तक ऐसी रीति से, जो बालक के हितों को सर्वोत्तम रूप से पूरा करती हो, पहुँच के लिए समुचित निदेश, और ऐसे अन्य आदेश, जो जिला न्यायालय बालक के हित में उचित समझे, सम्मिलित हो सकेंगे।
</p>
<p>
  जिला न्यायालय विवाह के किसी पक्षकार या उनके माता-पिता या संरक्षक द्वारा बालक के भरण-पोषण का उपबंध करने के लिए समुचित आदेश भी कर सकेगा।
</p>

<h6 className="gov-subheading">धारा-9 बाल-विवाह करने वाले पुरूष वयस्क के लिए दण्ड</h6>
<p>
  जो कोई, अट्ठारह वर्ष से अधिक आयु का पुरूष वयस्क होते हुए, बाल-विवाह करेगा, वह कठोर कारावास से, जिसकी अवधि दो वर्ष तक की हो सकेगी, या जुर्माने से, जो एक लाख रूपये तक का हो सकेगा, अथवा दोनों से, दण्डनीय होगा।
</p>

<h6 className="gov-subheading">धारा-10 बाल-विवाह का अनुष्ठान करने के लिए दण्ड</h6>
<p>
  जो कोई किसी बाल विवाह को सम्पन्न करेगा, संचालित करेगा, या निर्दिष्ट करेगा, या दुष्प्रेरित करेगा, वह जब तक यह साबित न कर दे कि उसके पास यह विश्वास करने का कारण था कि वह बाल विवाह नहीं था, कठोर कारावास से, जिसकी अवधि दो वर्ष तक की हो सकेगी, दण्डनीय होगा और जुर्माने से भी, जो एक लाख रूपये तक का हो सकेगा, दण्डनीय होगा।
</p>

<h6 className="gov-subheading">धारा-11 बाल-विवाह के अनुष्ठान का संवर्धन करने या उसे अनुज्ञात करने के लिए दण्ड</h6>
<p>
  जहाँ कोई बालक बाल-विवाह करेगा, वहाँ ऐसा कोई व्यक्ति जिसके भारसाधन में चाहे माता-पिता अथवा संरक्षक या किसी अन्य व्यक्ति के रूप में अथवा अन्य किसी विधिपूर्ण या विधि विरूद्ध हैसियत में, बालक है, जिसके अंतर्गत किसी संगठन या व्यक्ति निकाय का सदस्य भी है, जो विवाह का संवर्धन करने के लिए कोई कार्य करता है या उसका अनुष्ठापित किया जाना अनुज्ञात करता है या उसका अनुष्ठान किए जाने से निवारण करने में उपेक्षापूर्वक असफल रहता है, जिसमें बाल-विवाह में उपस्थित होना या भाग लेना सम्मिलित है, कठोर कारावास से, जिसकी अवधि दो वर्ष तक की हो सकेगी, दण्डनीय होगा और जुर्माने से भी, जो एक लाख रूपये तक का हो सकेगा, दण्डनीय होगा। परंतु कोई स्त्री कारावास से दण्डनीय नहीं होगी।
</p>
<p>
  इस धारा के प्रयोजनों के लिए, जब तक कि इसके प्रतिकूल साबित नहीं हो जाता है, वह उपधारणा की जाएगी कि जहाँ किसी अवयस्क बालक ने विवाह किया है वहाँ ऐसे अवयस्क बालक का भारसाधन रखने वाला व्यक्ति विवाह अनुष्ठापित किये जाने के निवारित करने में उपेक्षापूर्वक असफल रहा है।
</p>

<h6 className="gov-subheading">धारा-12 कतिपय परिस्थितियों में किसी अवयस्क बालक के विवाह का शून्य होना</h6>
<p>
  जहाँ कोई बालक जो अवयस्क है, विवाह के प्रयोजन के लिए - विधिपूर्ण संरक्षक की देखरेख से बाहर लाया जाता है या आने के लिए फुसलाया जाता है, या किसी स्थान से जाने के लिए बलपूर्वक बाध्य किया जाता है या किन्हीं प्रबंचनापूर्ण साधनों से उत्प्रेरित किया जाता है, या विक्रय किया जाता है, और किसी रूप में उसका विवाह कराया जाता है या यदि अवयस्क विवाहित है और उसके पश्चात् उस अवयस्क का विक्रय किया जाता है या दुर्व्यापार किया जाता है या अनैतिक प्रयोजनों के लिए उसका उपयोग किया जाता है, वहां ऐसा विवाह अकृत और शून्य होगा।
</p>

<h6 className="gov-subheading">धारा-15 अपराधों का संज्ञेय और गैरजमानतीय होना</h6>
<p>
  दण्ड प्रक्रिया संहिता 1973 में किसी बात के होते हुए भी, इस अधिनियम के अधीन दण्डनीय अपराध संज्ञेय और गैरमानतीय होगा।
</p>

<h6 className="gov-subheading">धारा-16 बाल-विवाह प्रतिषेध अधिकारी</h6>
<p>
  राज्य सरकार राजपत्र में अधिसूचना द्वारा, सम्पूर्ण राज्य या उसके ऐसे भाग के लिए, जो उस अधिसूचना में विनिर्दिष्ट किया जाए, बाल-विवाह प्रतिषेध अधिकारी के नाम से ज्ञात, किसी अधिकारी या अधिकारियों की नियुक्ति करेगी, जिसकी अधिकारिता, अधिसूचना में विनिर्दिष्ट क्षेत्र या क्षेत्रों पर होगी।
</p>
<p>
  राज्य सरकार, किसी समाज सेवा में विख्यात किसी, स्थानीय सम्माननीय सदस्य या ग्राम पंचायत या नगरपालिका के किसी अधिकारी से या सरकार के अथवा किसी पब्लिक सेक्टर के उपक्रम के किसी अधिकारी की सहायता करने के लिए अनुरोध कर सकेगी और, यथास्थिति, ऐसा सदस्य, अधिकारी या पदाधिकारी तद्नुसार कार्रवाई करने के लिए बाध्य होगा।
</p>

              </div>
            </details>

            {/* 5 */}
            <details
              className="info-block"
              open={openIndex === 4}
              onClick={() => toggleAccordion(4)}
            >
              <summary onClick={(e) => e.preventDefault()}>
                <span className="arrow"></span>
                <span className="gov-title">Child Labour (Prohibition and Regulation) CLPR Act, 1986 </span>
              </summary>
              <div className="gov-body">
               <h6 className="gov-subheading">बालक और कुमार श्रम (प्रतिषेध एवं विनियमन) अधिनियम, 1986 यथा संशोधित 2016</h6>

<h6 className="gov-subheading">धारा-3 किसी उपजीविका या प्रक्रिया में बालकों के नियोजन का प्रतिषेध</h6>
<p>
  किसी बालक को किसी उपजीविका या प्रक्रिया में नियोजन या कार्य करने के लिए अनुज्ञात नहीं किया जायेगा।
</p>
<p>
  उपधारा (1) की कोई बात वहां लागू नहीं होगी, जहाँ बालक अपने विद्यालय के समय के पश्चात् या प्रावकाशों के दौरान अपने कुटुम्ब या कुटुम्ब के ऐसे उद्यमों की सहायता करता है, जो अनुसूची में उपवर्णित परिसंकटमय उपजीविकाओं या प्रक्रियाओं से भिन्न है।
</p>
<p>
  किसी दृश्य-श्रव्य मनोरंजन उद्योग में, जिसके अंतर्गत विज्ञापन, फिल्म, टेलीविजन सीरियल या सर्कस के सिवाय ऐसे कोई अन्य मनोरंजन या खेल संबंधी क्रियाकलाप भी हैं, जो ऐसी शर्तों और सुरक्षा उपायों के अधीन रहते हुए, जो विहित किए जाएँ, कलाकार के रूप में कार्य करता है।
</p>

<h6 className="gov-subheading">धारा-3 क. कतिपय परिसंकटमय उपजीविकाओं और प्रक्रियाओं में कुमारों का प्रतिषेध</h6>
<p>
  कोई कुमार, अनुसूची में उपजीविकाओं या प्रक्रियाओं में काम करने के लिए नियोजन या अनुज्ञात नहीं किया जाएगा परंतु केन्द्रीय सरकार, अधिसूचना द्वारा ऐसे अपरिसंकटमय कार्य की प्रकृति विनिर्दिष्ट कर सकेगी, जिसमें किसी कुमार को इस अधिनियम के अधीन कार्य करने के लिए अनुज्ञात किया जा सकेगा।
</p>

<h6 className="gov-subheading">धारा-7 काम के घंटे और कालावधि</h6>
<p>
  किसी (कुमार) से किसी स्थापना में उतने घंटो से अधिक काम करने की अपेक्षा नहीं की जाएगी या अनुज्ञा नहीं दी जाएगी, जो ऐसे स्थापना या स्थापना के वर्ग के लिए विहित किए जाएँ।
</p>
<p>
  प्रत्येक दिन काम की कालावधि इस प्रकार नियत की जाएगी कि कोई कालावधि तीन घंटे से अधिक की नहीं होगी और कोई (कुमार) कम से कम एक घंटे का विश्राम अन्तराल ले चुकने से पूर्व तीन घंटे से अधिक काम नहीं करेगा।
</p>
<p>
  किसी (कुमार) के काम की कालावधि की व्यवस्था इस प्रकार की जाएगी कि वह उपधारा (2) के अधीन उसके विश्राम के अन्तराल सहित छह घंटों से अधिक की नहीं होगी, जिसके अन्तर्गत किसी दिन काम के लिए प्रतीक्षा में बिताया गया समय भी है।
</p>
<p>
  किसी (कुमार) से 7 बजे सायं और आठ बजे प्रातः के बीच काम करने की अपेक्षा नहीं की जाएगी या अनुज्ञा नहीं जाएगी।
</p>
<p>
  किसी (कुमार) से अतिकाल में काम करने की अपेक्षा नहीं की जाएगी या अनुज्ञा नहीं दी जाएगी।
</p>
<p>
  किसी (कुमार) से किसी स्थापना में ऐसे दिन काम करने की अपेक्षा नहीं की जाएगी या अनुज्ञा नहीं दी जाएगी, जिस दिन वह पहले से ही किसी अन्य स्थापना में काम कर रहा हो।
</p>

<h6 className="gov-subheading">धारा-10 आयु के बारे में विवाद</h6>
<p>
  यदि किसी ऐसे (कुमार) की, जो अधिष्ठाता द्वारा किसी स्थापन में काम करने के लिए नियोजित या अनुज्ञात किया जाता है, आयु के बारे में निरीक्षक और अधिष्ठाता के बीच कोई प्रश्न उत्पन्न होता है, तो वह प्रश्न, विहित चिकित्सा प्राधिकारी द्वारा ऐसे (कुमार) की आयु के बारे में दिए गए प्रमाणपत्र के अभाव में, निरीक्षक द्वारा विहित चिकित्सा प्राधिकारी को विनिश्चय के लिए निर्देशित किया जाएगा।
</p>

<h6 className="gov-subheading">धारा-11 रजिस्टर का रखा जाना</h6>
<p>
  प्रत्येक अधिष्ठाता द्वारा किसी स्थापना में काम करने के लिए नियोजित या अनुज्ञात (कुमारों) के संबंध में एक रजिस्टर रखा जाएगा जो काम के घंटों के दौरान सभी समयों पर या जब किसी ऐसे स्थापना में काम हो रहा हो, तब सभी समयों पर निरीक्षक द्वारा निरीक्षण के लिए उपलब्ध होगा, जिसमें निम्नलिखित दर्शित होंगे-
</p>
<ul>
  <li>काम के लिए इस प्रकार नियोजन या अनुज्ञात किए गए प्रत्येक (कुमार) का नाम और उसके जन्म की तारीख,</li>
  <li>किसी ऐसे (कुमार) के काम के घंटे और कालावधियां तथा विश्राम के वे अन्तराल जिनका वह हकदार है,</li>
  <li>किसी ऐसे (कुमार) के काम की प्रकृति, और</li>
  <li>ऐसी अन्य विशिष्टियां जो विहित की जाएँ।</li>
</ul>

<h6 className="gov-subheading">धारा-14 शास्तियां</h6>
<p>
  (1) जो कोई किसी बालक को धारा 3 के उपबंधों के उल्लंघन में नियोजित करता है या काम करने के लिए अनुज्ञात करता है, वह कारावास से, जिसकी अवधि छह मास से कम की नहीं होगी, किन्तु जो दो वर्ष तक की हो सकेगी या जुर्माने से, जो बीस हजार से कम का नहीं होगा, किन्तु जो पचास हजार रूपये तक का हो सकेगा, अथवा दोनों से, दंडनीय होगा।
</p>
<p>
  (1क) जो कोई किसी कुमार को धारा 3 के उपबंधो के उल्लंघंन में नियोजित करता है या काम करने के लिए अनुज्ञात करता है, वह कारावास, जिसकी अवधि छह मास के कम की नहीं होगी किन्तु जो दो वर्ष तक की हो सकेगी या जुर्माने से, जो बीस हजार रूपये से कम का नहीं होगा, किन्तु जो पचास हजार रूपये तक का हो सकेगा, अथवा दोनों से, दंडनीय होगा।
</p>
<p>
  परंतु ऐसे कुमार के माता-पिता या संरक्षक को तब तक दण्डित नहीं किया जाएगा जब तक कि वे ऐसे कुमार को, धारा 3 के उपबंधों के उल्लंघन में कार्य करने के लिए अनुज्ञात न करें।
</p>
<p>
  (1ख) उपधारा (1) और उपधारा (1क) में अन्तर्विष्ट किसी बात के होते हुए भी धारा 3 या धारा 3 (क) में निर्दिष्ट किसी बालक या कुमार के माता-पिता या संरक्षक प्रथम अपराध की दशा में दंड के भागी नहीं होंगे।
</p>
<p>
  14. (क) अपराधों का संज्ञेय होना दंड प्रक्रिया संहिता, 1973 (1974 का 2) में अन्तर्विष्ट किसी बात के होते हुए भी किसी नियोजक द्वारा किया गया और धारा 3 या धारा 3 (क) के अधीन दंडनीय कोई अपराध संज्ञेय होगा।
</p>
<p>
  14. (ख) बालक और कुमार श्रम पुनर्वास निधि (1) समुचित सरकार, प्रत्येक जिले में अथवा दो या अधिक जिलों के लिए बालक और कुमार श्रम पुनर्वास निधि नामक एक निधि की स्थापना करेगी, जिसमें ऐसे जिले या जिलों की अधिकारिता के भीतर बालक और कुमार के नियोजक से वसूल की गई जुर्माने की रकम जमा की जाएगी।
</p>
<p>
  14 (ग) छुड़ाए गए बालक या कुमार का पुर्नवास ऐसे बालक या कुमार का, जो इस अधिनियम के उपबंधों के उल्लंघन में नियोजित किया गया है और उसे छुड़ा लिया गया है, तत्समय प्रवृत्त विधि के अनुसार पुर्नवास किया जाएगा।
</p>
<p>
  14 (घ) अपराधों का शमन-(1) दंड प्रक्रिया संहिता, 1973 (1974 का 2) में अन्तर्विष्ट किसी बात के होते हुए भी, जिला मजिस्ट्रेट, अभियुक्त व्यक्ति के आवेदन पर उसके धारा 14 की उपधारा (3) के अधीन पहली बार किए गए किसी अपराध का या किसी ऐसे अभियुक्त व्यक्ति द्वारा, जो माता-पिता या संरक्षक है, किए गए किसी अपराध का, ऐसी रीति में और समुचित सरकार को ऐसी रकम का संदाय करने पर, जो विहित की जाए, शमन कर सकेगा।
</p>

<h6 className="gov-subheading">धारा-16 अपराधों से संबंधित प्रक्रिया</h6>
<p>
  (1) कोई व्यक्ति, पुलिस अधिकारी या निरीक्षक इस अधिनियम के अधीन किसी अपराध के लिए जाने का परिवाद सक्षम अधिकारिता वाले किसी न्यायालय में कर सकेगा।
</p>
<p>
  (2) किसी बालक की आयु के बारे में प्रत्येक प्रमाण-पत्र, जो विहित चिकित्सा प्राधिकारी द्वारा दिया गया है, इस अधिनियम के प्रयोजनों के लिए, उस बालक की, जिससे वह संबंधित है, आयु के बारे में निश्चायक साक्ष्य होगा।
</p>
<p>
  (3) महानगर मजिस्ट्रेट या प्रथम वर्ग मजिस्ट्रेट के न्यायालय से अवर कोई न्यायालय इस अधिनियम के अधीन किसी अपराध का विचारण नहीं करेगा।
</p>

<h6 className="gov-subheading">धारा-17 निरीक्षक की नियुक्ति</h6>
<p>
  समुचित सरकार, इस अधिनियम के उपबन्धों का अनुपालन सुनिश्चित करने के प्रयोजनों के लिए निरीक्षक नियुक्त कर सकेगी और इस प्रकार नियुक्त किया गया कोई निरीक्षक भारतीय दण्ड संहिता (1860 का 45) के अर्थ में लोक सेवक समझा जाएगा।
</p>

<h6 className="gov-subheading">(क) जिला मजिस्ट्रेट द्वारा उपबंधों का कार्यान्वयन किया जाना</h6>
<p>
  समुचित सरकार, जिला मजिस्ट्रेट को यह सुनिश्चित करने के लिए कि इस अधिनियम के उपबंधों का उचित रूप से कार्यन्वयन किया जाए, ऐसी शक्तियां प्रदान कर सकेगी और उस पर ऐसे कर्तव्य अधिरोपित कर सकेगी, जो आवश्यक हों तथा जिला मजिस्ट्रेट, उसके अधीनस्थ ऐसे अधिकारी को, जो इस प्रकार प्रदत्त या अधिरोपित सभी या किन्हीं शक्तियों का प्रयोग करेगा और सभी या किन्हीं कर्तव्यों का निर्वहन करेगा तथा ऐसी स्थानीय सीमाओं को, विनिर्दिष्ट कर सकेगा जिनके भीतर ऐसी शक्तियों या कर्तव्यों का निर्वहन किसी ऐसे अधिकारी द्वारा, जो विहित किया जाए, किया जाएगा।
</p>

<h6 className="gov-subheading">(ख) निरीक्षण और मॉनीटर करना</h6>
<p>
  समुचित सरकार, ऐसे स्थानों का, जहां पर बालकों का नियोजन प्रतिषिद्ध है, और परिसंकटमय उपजीविकाओं या प्रक्रियाओं को किया जाता है ऐसे अंतरालों पर, जो वह ठीक समझे, कालिक निरीक्षण करने और करवाने के लिए और इस अधिनियम के उपबंधों से संबंधित मुद्दों को मॉनीटर करेगी।
</p>

              </div>
            </details>

            {/* 6 */}
            <details
              className="info-block"
              open={openIndex === 5}
              onClick={() => toggleAccordion(5)}
            >
              <summary onClick={(e) => e.preventDefault()}>
                <span className="arrow"></span>
                <span className="gov-title"> Pre-Conception and Pre-Natal Diagnostic Techniques (Prohibition of Sex Selection) PCPNDT Act, 1994 </span>
              </summary>
              <div className="gov-body">
               <h6 className="gov-subheading">1.गर्भधारण पूर्व और प्रसर्वपूर्व निदान तकनीक (लिंग चयन प्रतिषेध) अधिनियम, (PCPNDT) 1994</h6>

<p>
  गर्भधारण से पूर्व या उसके पश्चात लिंग चयन के प्रतिषेध का और आनुवंशिकी अप्रसमान्यताओं या मेटाबोली विकारों या गुणसुत्री अप्रसमान्यताओं या कतिपय जन्मजात विकृतियों या लिंग-संबद्ध विकारों का पता लगाने के प्रयोजनों के लिए प्रसवपूर्व निदान तकनीकों के विनियमन का तथा लिंग अवधारणा के लिए ऐसी तकनीकों के, जिनके कारण कन्या भ्रूण हत्या हो सकती हो, दुरूपयोग के निवारण का तथा उनसे सम्बन्धित या उनके आनुषंगिक विषयों का उपबन्ध करने के लिए यह अधिनियम बनाया गया है।
</p>
<p>
  इस अधिनियम के अन्तर्गत गर्भावस्था को समाप्त करने की अनुमति तभी दी जाती है, जब गर्भ को जारी रखने की सलाह नहीं दी गयी हो और गर्भ महिला के जीवन के लिए खतरा बन रहा हो और यह गर्भवती को गंभीर रोगों से पीड़ित बना सकता हो।
</p>

              </div>
            </details>

          </div>
        </div>
      </section>
    </div>
  );
}
